import { FC } from "react";
import { BooleanLiteral } from "typescript";

import LazyLoadImage from "web/Layout/Common/LazyLoadImage";
import __ from "web/Layout/Translations";

import Button from "web/Components/Common/ButtonCC";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import defaultStyles from "./banner.scss";

interface IPageGeneratorBannerProps {
  url?: string;
  imageSrc?: string;
  alt?: string;
  buttonTitle?: string;
  isButtonVisible?: BooleanLiteral;
}

const PageGeneratorBanner: FC<PropsWithClasses<IPageGeneratorBannerProps>> = ({
  imageSrc = "",
  alt = "",
  url = "none",
  classes = {},
  buttonTitle = "",
  isButtonVisible = true,
}) => {
  return (
    <div className={classes.root}>
      {imageSrc && (
        <LazyLoadImage
          className={classes.image}
          src={imageSrc}
          alt={alt}
          isAutoresized={false}
        />
      )}
      {isButtonVisible && (
        <Button className={classes.link} to={url}>
          {__(buttonTitle || "Zobacz więcej")}
        </Button>
      )}
    </div>
  );
};

export default classify(defaultStyles)(PageGeneratorBanner);
